import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000/api',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
})

export default {
  // Tasks
  getTasks(status = null) {
    const params = status ? { status } : {}
    return api.get('/tasks', { params })
  },
  createTask(data) {
    return api.post('/tasks', data)
  },
  updateStatus(id, status) {
    return api.patch(`/tasks/${id}/status`, { status })
  },
  deleteTask(id) {
    return api.delete(`/tasks/${id}`)
  },
  // Report
  getReport(date) {
    return api.get('/tasks/report', { params: { date } })
  }
}